import { z } from 'zod'

import { PiloteBackgroundCheckStatusZod } from '../common'

export const PREANALYSIS_NOTE_MAX_LENGTH = 2000

export const JudicialPreanalysisStatusZod = z.enum(['new', 'inProgress', 'toCommunicate', 'done'])
export type JudicialPreanalysisStatus = z.infer<typeof JudicialPreanalysisStatusZod>

export const JudicialPreanalysisCentralZod = z.object({
  centralId: z.number(),
  volunteerId: z.number().nullish().default(null),
  name: z.string(),
  campaignId: z.number().nullable(),
  registrationDate: z.date().nullable(),
})

export const JudicialPreanalysisZod = z.object({
  personCode: z.string(),
  firstName: z.string().nullish().default(''),
  lastName: z.string().nullish().default(''),
  centrals: z.array(JudicialPreanalysisCentralZod).nullish().default([]),
  centralIds: z.array(z.number()).nullish().default([]),
  registrationDate: z.date().nullish().default(null),
  decision: PiloteBackgroundCheckStatusZod.nullish().default(null),
  decisionDate: z.date().nullish().default(null),
  status: JudicialPreanalysisStatusZod.nullish().default('new'),
  note: z.string().nullish().default(null),
  createdAt: z.date().nullish().default(null),
  updatedAt: z.date().nullish().default(null),
  updatedBy: z.string().nullish().default(null),
})
export type JudicialPreanalysis = z.infer<typeof JudicialPreanalysisZod>
